import React from 'react';
import { MarkdownList } from '../list';
import { MarkdownTable } from '../table';
import { MarkdownBlockquote } from '../blockquote';
import { MarkdownHeading } from '../heading';
import { MarkdownParagraph } from '../paragraph';
import { MarkdownHorizontalRule } from '../horizontal-rule';
import { IBlockquoteComponentModel } from '../../parser/blockquote';
import { IComponentSource, MarkdownComponent } from '../../parser/core';
import { IHorizontalRuleComponentModel } from '../../parser/horizontal-rule';
import { IListComponentModel } from '../../parser/list';
import { IParagraphOrHeaderComponentModel } from '../../parser/paragraph-header';
import { ITableComponentModel } from '../../parser/table';

interface IMarkdownContentProps {
  componentModel: IComponentSource;
  hostSectionIsTimed: boolean;
}

export const MarkdownContent: React.FunctionComponent<IMarkdownContentProps> = (props) => {
  const { componentModel } = props;

  return (
    <>
      {(componentModel.type === MarkdownComponent.OrderedList || componentModel.type === MarkdownComponent.UnorderedList) &&
      <MarkdownList {...componentModel as IListComponentModel}/>}
      {componentModel.type === MarkdownComponent.Table && <MarkdownTable {...componentModel as ITableComponentModel}/>}
      {componentModel.type === MarkdownComponent.Blockquote && <MarkdownBlockquote {...componentModel as IBlockquoteComponentModel}/>}
      {componentModel.type === MarkdownComponent.Paragraph && <MarkdownParagraph {...componentModel as IParagraphOrHeaderComponentModel}/>}
      {componentModel.type === MarkdownComponent.Heading &&
      <MarkdownHeading
        hostSectionIsTimed={props.hostSectionIsTimed}
        componentModel={componentModel as IParagraphOrHeaderComponentModel}
      />}
      {(componentModel.type === MarkdownComponent.ThickRule || componentModel.type === MarkdownComponent.ThinRule) &&
      <MarkdownHorizontalRule {...componentModel as IHorizontalRuleComponentModel}/>}
    </>
  );
};
